export default {

    /* RAE */
    RAE: 'RAE',
    RAE_SUBTITLE: 'Lista de Processos Pendentes de Aprovação',
    PENDING: 'Pendentes',
    APPROVED: 'Aprovados',
    REJECTED: 'Rejeitados',
    REJECTED_RAES_ONLY: 'Apenas processos com RAE rejeitado',
    CANCELED: 'Cancelados',
    CURRENT_ROUND: 'Round Atual',
    PROCESSES_PACKAGES: 'Processos / Pacotes',
    DOC_TYPE: 'Tipo de documento',
    APPROVAL_TEAM: 'Time aprovador',
    RAE_DETAILS: 'Detalhes RAE',
    RAE_PENDING: 'Pendentes RAE',
    FROM_PACKAGE: 'O item selecionado pertence ao pacote {0}, confirme abaixo os itens do pacote {0} que irão para a criação do RAE.',
    FROM_PROCESS: 'Este item pertence ao processo {0}',
    FROM_PROCESS_ITEMS: 'Confirme abaixo os itens selecionados para a criação do RAE.',
    OTHER_PROCESSES_FROM_PACKAGE: 'Outros processos pertencentes a este pacote:',
    OTHER_ITEMS_FROM_PROCESS: 'Outros items pertencentes a este processo:',
    PROCEED_TO_CRIATION: 'Prosseguir para criação',
    RAE_CRIATION: 'Criação de RAE',
    PROCESS_TITLE: 'Processo {0} - Linha {1}',
    CREATE_RAE: 'Criar RAE',
    RAE_DATA: 'Dados do RAE',
    STATUS_UPDATE_DATE: 'Data de atualização do status',
    NECESSARY_APPROVALS: 'Número de aprovações necessárias',
    APPROVAL_NUMBER: 'Número da aprovação atual',
    APPROVER_NARRATIVE: 'Narrativa do aprovador',
    NO_QUOTATION_INFORMED: 'Sem cotação informada',
    NO_TEAM_TYPE_INFORMED: 'Sem time aprovador informado',
    NO_APPROVER_INFORMED: 'Sem aprovador informado',
    NO_INTERVAL_INFORMED: 'Sem intervalo de valores informado',

    IMPORT: 'Importar',
    MAX_SIZE_FILE: 'O tamanho do arquivo superou o tamanho máximo de {0} mb',
    NEW_ATTACHMENTS: 'Enviar anexos',
    SEND_NEW_ATTACHMENT: 'Envio de um Novo Anexo',
    LIST_ATTACHMENTS: 'Lista de Alterações',
    SEND_ATTACHMENT: 'Envie um anexo',
    ATTACHMENT: 'Anexo',
    NO_ATTACHMENTS: 'Sem anexos vinculados',
    NO_APPROVALS: 'Sem aprovações no momento',
    EDIT_RAE: 'Editar RAE',
    CANCEL_RAE: 'Cancelar RAE',
    CONFIRM_RAE_EDITION: 'Confirmação de edição de RAE',
    RAE_EDITION_INFO: `
        Ao confirmar que você deseja acessar a edição do documento o mesmo deverá
        passar por todas as alçadas de aprovação novamente. Deseja continuar?
    `,
    PROCEED_TO_EDITION: 'Prosseguir para edição',
    CONFIRM_REJECT_RAE: 'Confirmar rejeição de RAE',
    CONFIRM_APPROVE_RAE: 'Confirmar aprovação de RAE',
    CONFIRM_CANCEL_RAE: 'Confirmar cancelamento de RAE',
    RAE_REJECTION_REASON: 'Por que esse processo está sendo rejeitado?',
    TO_CREATE_RAE: 'Prosseguir para criação',
    CREATE_RAE: 'Criação de RAE',
    ATTACHMENTS_RAE_ERROR: 'Erro ao enviar anexos, tente novamente!',
    INFO_MAIN_RAE_DOC_ATTACHMENT: 'É obrigatório anexar o documento referente ao tipo do RAE escolhido em formato ".doc" ou ".docx"',

    IMPORT: 'Importar',
    MAX_SIZE_FILE: 'O tamanho do arquivo superou o tamanho máximo de {0} mb',
    SEND_NEW_ATTACHMENT: 'Envio de um Novo Anexo',

    RAE_HISTORIC: 'Histórico do RAE',
    SELECT_RAE: 'Selecione um RAE ao lado para visualizar seus detalhes',

    //-------
    RAE_APPROVAL: 'RAE Approval - RAE 批准',
    RAE_REJECTION: 'RAE Rejection - RAE 拒绝',
    APPROVE: 'Approve - 批准',
    REJECT: 'Reject - 拒绝',
    PUBLIC_RAE_ERROR_MESSAGE: 'Error fetching RAE. Please try again - 获取RAE时出错。请重试',



    CHANGE_APPROVAL: 'Solicitação de Alteração Aprovada!',
    CHANGE_REJECT: 'Data do Contrato/Pedido Aprovado - Realizado rejeitada!',
    PUBLIC_APPROVAL_ERROR_MESSAGE: 'Erro ao executar ação desejada para a data de aprovação. Tente novamente',
    CANT_SELECT_ITEMS_AND_PACKAGE: 'Não é permitido selecionar itens em pacote e itens avulsos ao mesmo tempo.',
    ERR_DOWNLOAD_ATTACHMENT: 'Não foi possível concluir o download do arquivo',
    ERR_DOWNLOAD_ATTACHMENT_WITH_ERROR: 'Não foi possível concluir o download do arquivo por conta de inconsistencias de banco. Entre em contato com o Suporte para mais detalhes',
    DISABLED_RAE_TYPES: 'Tipo(s) de documentos desabilitado(s)',
    PRIORITY: 'Prioridade',
    NORMAL: 'Normal',
    PROCESS_SUMMARY: 'Resumo do Processo',
    SUPPLIER: 'Fornecedor',
    VALUE: 'Valor',
    INVALID_NUMBER: 'Número inválido',
    ERROR_DIFFERENT_CODE_ESTABLISHMENT: 'Não é permitido selecionar itens de diferentes estabelecimentos',
    RESEND_RAE_TO_APPROVAL: 'Reenviar para Aprovação',
    CONFIRM_RESEND_RAE_TO_APPROVAL: 'Tem certeza que deseja reenviar este RAE para Aprovação?',
    BASELINE: 'Baseline',
    BASELINE_REFERENCE: 'Referência de Baseline',
    ERROR_RAE_WITH_PROCESSES_WITHOU_CONVERSATION_VALUES: 'Este RAE não pode ser criado porque há itens sem negociação com valor informado. Seguem itens abaixo:',

    // Modal returned processes
    SELECT_RETURNED_PROCESS: 'Selecione um processo devolvido ao lado para visualizar seus detalhes',
    RETURNED_DATE: 'Data da devolução',
    RETURNED_STATUS: 'Status da devolução',
    OPTION_STATUS_RETURNED_REQUESTER: 'Devolvido para área requisitante',
    OPTION_STATUS_RETURNED_REQUESTED: 'Devolução solicitada - Em Aprovação',
    ITEM_RETURNED_DATA: 'Dados da devolução',
    TRSM: 'TRSM',
    BUYERS: 'Compradores',
    RETURN_MOTIVE_DESCRIPTION: 'Motivo da devolução',
    NO_PROCESSES_RETURNED: 'Nenhum processo devolvido',

    /* BudgetAdequacy Modal */
    BUDGET_ADEQUACY_CREATION: 'Cadastro de Adequação Orçamentária',
    BUDGET_ADEQUACY: 'Adequação Orçamentária',
    ERROR_CANT_SELECT_ITEM_WITH_PACKAGE: 'Não é possivel solicitar a adequação orçamentária de um item pertencente a um pacote',
    VINCULATED_PROCESS: 'Processo vinculado',
    BUDGET_ADEQUACY_TO_CREATE: 'Criar Adequação Orçamentária',
    EMAIL_BODY: 'Corpo do Email',
    USER_EMAIL: 'Email do usuário',
    BUDGET_ADEQUACY_DETAILS: 'Detalhes de Adequação Orçamentária',
    REQUISITION_BODY: 'Corpo da solicitação',
    ANSWER_BODY: 'Corpo da resposta',
    REQUISITION_RESPONSE: 'Resposta da solicitação',
    BUYER_EMAIL: 'E-mail do comprador',
    TO_RESPOND_BUDGET_ADEQUACY: 'Responder Adequação Orçamentária',
    NOT_ANSWERED_REQUESTER: 'Esta solicitação ainda não foi respondida',

    /* TECHNICAL REPORT */
    TECHNICAL_ADVICE_CREATION: 'Cadastro de Parecer Técnico',
    TECHNICAL_ADVICE: 'Parecer Técnico',
    ERROR_CANT_SELECT_ITEM_WITH_PACKAGE_TECHNICAL_ADVICE: 'Não é possivel solicitar parecer técnico de um item pertencente a um pacote',
    TECHNICAL_ADVICE_TO_CREATE: 'Criar Parecer Técnico',
    SUPPLIERS: 'Fornecedores',
    PROCESS_SUPLIERS: 'Fornecedores do processo',
    ADD_SUPPLIER: 'Adicionar Fornecedor',
    ADD_EMAIL: 'Adicionar Email',
    NO_SUPPLIER_ERRO: 'É necessário adicionar ao menos um fornecedor antes de finalizar o parecer técnico',
    NO_COPY_EMAILS_ERRO: 'É necessário adicionar ao menos um email para envio antes de finalizar o parecer técnico',
    TECHNICAL_REPORT_CREATION_SUCCESS: 'Cadastro de Parecer Técnico realizado com sucesso',
    TO_RESPOND_TECHNICAL_REPORT: 'Responder Parecer Técnico',
    TECHNICAL_REPORT_RESPONDED: 'Parecer Técnico respondido com sucesso',
    TECHNICAL_REPORT_DETAILS: 'Detalhes do Parecer Técnico',
    SUPPLIER_LIMIT_REACHED: 'Não é permitido cadastrar mais de {0} fornecedores',
    CURRENT: 'Atual',
    EMAILS_TO_RECIVE_COPY_CREATE: 'E-mails para enviar como cópia',
    EMAILS_TO_RECIVE_COPY_DETAIL: 'E-mails enviados por cópia',
    EMAILS_TO_RECIVE_DETAIL: 'E-mails enviados',
    EMAILS_TO_RECIVE: 'E-mails para envio',
    COPY_EMAIL_TYPE: 'Email em cópia',
    NORMAL_EMAIL_TYPE: 'Envio principal',

    ERROR_DESELECT_EMAIL_BUYER: 'O e-mail do comprador não pode ser removido',
    ERROR_MAX_EMAILS_TO_RECIVE_COPY: 'Não é possível adicionar mais e-mails',

    /* Tooltips */
    ITEM_NARRATIVE_FILTER_WARNING: 'Use ";" para separar o texto e pesquisar por vários trechos de narrativas simultaneamente.',
    FILTER_WARNING_FOR_MULTIPLE_OPTIONS: 'Use ";" para separar o texto e pesquisar por vários trechos de {0} simultaneamente.',

    /* Requisitantes Sugeridos */
    SUGGESTED_REQUESTERS: 'Requisitantes Sugeridos',
    ADD_REQUESTERS: 'Adicionar requisitantes',
    EMAIL_ALREADY_SELECTED: 'O email {0} já foi selecionado!',

    /* Tab Aprovadores */
    APPROVERS: 'Aprovadores',
    APPROVERS_FROM_COMPANY: 'Aprovadores da Empresa:',
    SIGNATURE_NOT_FOUNDED: 'Assinatura não cadastrada',
    INTERVAL: 'Intervalo',
    APPROVER_TOOLTIP_INFO: 'Pesquise pelo email',
    INTERVAL_TOOLTIP_INFO: 'Apenas o intervalo final pode ser enviado sem valor máximo, e nesse caso todos os valores acima dele serão atribuidos a este aprovador',
    MIN_VALUE: 'Valor mínimo',
    MAX_VALUE: 'Valor máximo',
    UPDATE_SIGNATURE_IMAGE: 'Atualizar imagem de assinatura',
    NEW_SIGNATURE_IMAGE: 'Inserir imagem de assinatura',
    ERROR_GET_SIGNATURE: 'Erro ao buscar imagem de assinatura de {0}',
    EDIT_SIGNATURES_CONFIRM: 'Deseja mesmo atualizar os parâmetros de aprovação e assinaturas do sistema?',
    NUMBER_RAE: 'Nro.',
    STATUS_RAE: 'Status Atual',
    APPROVED_VALUE_RAE: 'Valor',

    /* ContractEscape */
    CONTACT_ESCAPE: 'Fuga de Contrato',
    CODE_CONTRACT: 'Código do Contrato',
    CONTACT_ESCAPE_REASON: 'Motivo da fuga do contrato',
    CONTACT_ESCAPE_SUCCESS: 'Fuga de contrato realizada com sucesso',

    REMOVE_ITEM_CONTRACT_ESCAPE_POPCONF: 'Deseja realmente remover um processo por Fuga de Contrato?',
    REMOVE_ITEM_COMEX_POPCONF: 'Deseja realmente remover um item por COMEX?',
    COMEX_ITEM_SUCCESS: 'Item de COMEX removido com sucesso',

    /* Divergencias */
    DIVERGENCES: 'Divergências',
    DIVERGENCE: 'Divergência',
    DIVERGENCE_STATUS: 'Status da divergência',
    CREATED_BY: 'Criado por',
    NF_ATTACHMENT: 'Anexo de NF',
    CONFERENCE_ATTACHMENT: 'Anexo de Conferência',
    DIVERGENCE_TITLE: 'Divergência {0} {1} {2} - Linha {3}',
    INVOICE_DETAILS: 'Detalhes da Nota Fiscal',
    SUPPLIER_NAME: 'Nome do fornecedor',
    SUPPLIER_CGC: 'Documento do fornecedor',
    OPERATION_NATURE: 'Natureza da operação',
    INVOICE: 'Nota Fiscal N° {0} - Série {1}',
    NF_NUMBER: 'Nro da nota fiscal',
    NF_SERIE: 'Série da nota fiscal',
    SERIE: 'Série',
    TOTAL_VALUE: 'Valor Total',
    PROTOCOL: 'Protocolo',
    FLUIG: 'FLUIG',
    FLUIG_PROTOCOL: 'Protocolo FLUIG',
    RUNNING_TIME: 'Tempo Percorrido',

    /* LogsIntegration */
    LOGS_INTEGRATION: 'Logs de Integração',
    RUN_INTEGRATION: 'Rodar Integração',
    RUN_INTEGRATION_DETAILS: 'Detalhes da Integração',
    RUN_INTEGRATION_WARNING_MESSAGE: 'Atenção, para rodar a rotina de novos processos, as seguintes tabelas do PIS devem estar atualizadas: ',
    NO_ROWS_GRID_MIDDLEWARE_ACTIVATION_LOG_RETURNS: 'Nenhum histórico de log de rotina de integração',
    ROUTINE: 'Rotina',
    NEW_OCS_COUNT: "Novas OC's: {0}",
    NEW_SCS_COUNT: "Novas SC's: {0}",
    FINISHED: 'Finalizados',
    INTEGRATION_NEW_PROCCESS_SUCCESS: 'Rotina de integração de processos iniciada com sucesso.',
    INTEGRATION_NEW_PROCCESS_SUCCESS_MESSAGE: 'Atualize a tabela dentro de alguns minutos para conferir se a rotina já foi finalizada',
    EXECUTED_BY: 'Executado por',
    TO_UPDATE: 'Atualizar',
    UPDATED_DATA: 'Dados atualizados',
    CREATED_PROCESSES: 'Processos criados',

    APPIAN_SLOGAN: 'End to End Supply Chain, Client Oriented, Cost Driven and Powered by KPIs',

    SUGGEST: 'Sugerir {0}',
    ERROR_MULTIPLE_ROWS_SELECTED_SUGGEST: 'Selecione apenas uma linha para sugerir {0}',
    PROCESSES_PENDING_APPROVAL: 'Alterações Pendentes de Aprovação',

    CONFIRM_APPROVE: 'Deseja confirmar aprovação?',
    CONFIRM_REJECT: 'Deseja confirmar rejeição?',

    PROCESS_CHANGES_DETAILS: 'Detalhes alterações solicitadas',
    REQUESTED_CHANGES: 'Alterações solicitadas',

    PROCESS_CHANGE_PENDING_STATUS_TITLE: 'Alteração de Processo Pendente',
    PROCESS_CHANGE_APPROVED_STATUS_TITLE: 'Alteração de Processo Aprovada',
    PROCESS_CHANGE_REJECTED_STATUS_TITLE: 'Alteração de Processo Rejeitada',

    /* Process Changes */
    APPROVE_CHANGE_SUCCESS: 'Sucesso ao aprovar alteração de processo',
    REJECT_CHANGE_SUCCESS: 'Sucesso ao rejeitar alteração de processo',

    REJECT_CHANGE_MOTIVE: 'Motivo da Rejeição',
    CHANGE_SOLICITATIONS: 'Solicitações de alteração',
    CHANGES_REQUESTER_USER: 'Usuário solicitante das alterações',
    CHANGES_REQUESTER_APPROVER: 'Usuário aprovador',
    INVALID_STATUS: 'Status invalido',
    MUST_HAVE_APPROVER_NARRATIVE: 'Atenção! É obrigatório inserir um motivo para a rejeição',

    ORDER_APPROVAL_LAST_MONTH_MODAL_DESCRIPTION:
        'O campo "Contrato/Pedido Aprovado - Realizado" identificou uma data referente ao mês anterior. Nesse caso será necessário que o processo passe por uma sequência de aprovações.',
    PURCHASE_MODALITY_CHANGE_CONFIRM_MODAL_DESCRIPTION: 'Os seguintes campos dos seguintes processos irão alterar a modalidade da contratação para reforma externa. Confirme as ações!',
    PURCHASE_MODALITY_CHANGE_CONFIRM_MODAL_INFO: 'A edição atual irá  alterar a modalidade da contratação para reforma externa. Tem certeza que deseja fazer isso?',
    ERROR_CONFIRM_EDITIONS: 'Não há ações confirmadas, para calcelar todas as alterações clique em cancelar abaixo, para confirmar selecione as edições desejadas',
    PLEASE_INFORM_DATE_AGAIN: 'Por favor, informe a data novamente!',
    PROCESS_IDS: 'IDs dos Processos: ',
    INFORMED_DATE: 'Data Informada: {0}',

    PROCESS_CHANGE_MOTIVE: 'Motivo',

    PROCESS_CHANGE_CREATE_ERROR: 'Problemas ao criar solicitação de alteração de processo.',
    PROCESS_CHANGE_CREATE_SUCCESS: 'Sucesso ao criar solicitação de alteração de processo.',

    // Dashboards
    PROCESSES_DASHBOARD: 'Dashboard dos Processos',

    DELETION_PROCESSES_REQUESTS: 'Solicitações de remoção de processos',
    PENDING_DELETION_PROCESSES_REQUESTS: 'Solicitações de remoção de processos pendentes',
    REQUEST_DETAILS: 'Detalhes da solicitação',
    CONTRACT_DELETE_MOTIVE_CODE: 'Motivo para remoção do processo',
    COMEX_ITEMS: 'Itens de COMEX',

    HISTORIC_PROCESS_DETAILS: 'Histórico',

    USER_ACTION_LOGS: 'Logs de Ação do Usuário',
    ACTION_DATE: 'Data da ação',
    EXPORT_EXCEL_CARTEIRA: 'Exportação de dados do grid da Carteira',
    NO_ROWS_GRID_USER_ACTION_LOG: 'Nenhum log de ação do usuário',

    PROCESS_DASHBOARD_SECTION: 'Aba de dashboard dos processos',
    POWER_BI_SECTION: 'Aba de Power BI',
    GRID_ACTIONS_SECTION: 'Ações relacionadas ao Grid em si',
    GRID_ITEMS_ACTIONS_SECTION: 'Ações relacionadas aos itens no Grid',
    GRID: 'Grid',

    DOC_QUESTION: 'Esconder documentação interativa?',
    GENERAL_DOC: 'Visualizar documentação geral',
    EDITIONS: 'Edições',
    FILTERS: 'Filtros',
    EXPORTATION: 'Exportação',
    MACROSTAGES: 'Macroetapas',
    APPROVALS: 'Aprovações',
    ITEM_HISTORY: 'Hisótrico do Item',
    RAE_DETAILS: 'Detalhes do RAE',
    RAE_EDITION: 'Edição de RAE',
    RESEND_RAE_APPROVAL: 'Ação de reenvio de RAE para alçada de aprovação',
    APPROVAL_AND_REJECT_RAE: 'Aprovação e rejeição de RAE',
    ACTIONS_BUTTONS: 'Botões de ações',
    APPROVAL_BUTTONS: 'Botões de aprovação',
    ERROR_DETAILS_MODAL: 'Modal de detalhes do erro',
    EDITION_DETAILS_MODAL: 'Modal de detalhes da edição',
    ACTION_RUN_INTEGRATION_NEW_PROCESSES: 'Ação de Rodar integração de novos processos',
    CREATE_PROCESSES_MODAL: 'Modal de processos criados',
    ACTION_UPDATE_TABLE: 'Ação de atualizar tabela',
    ORDENATION: 'Ordenação',
    PROCESSES_PENDING_APPROVAL: 'Processos Pendentes de Aprovação',

    CREATE_PACKAGES_RULES: 'Regras gerais de criação de pacotes',

    END_NEGOTIATION_INFO:
        'Ao encerrar a negociação com o fornecedor, você não poderá mais adicionar mensagens de contato referentes à negociação com o mesmo. Caso o motivo de finalização abaixo for "Aceito", o fornecedor estará apto a ser selecionado na etapa de homologação interna (RAE).',
    SAVE_NEGOTIATED_VALUES: 'Salvar Valores Negociados',
    SUCCESS_SAVE_NEGOTIATED_VALUES: 'Valores negociados negociados salvos',

    RAE_NEGOTIATION_STATUS: 'Status de Negociação Final',

}
